<style scoped>
  .card {
    transition: .5s;
  }
  .item {
    margin-bottom: 16px;
  }
  .item:last-child{
    margin-bottom: 0;
  }
</style>
<template>
  <v-card
    class="card"
    outlined
    :elevation="elevation"
  >
    <v-card-title>
      {{ bill.uid }}
      <space />
    </v-card-title>
    <v-card-subtitle>
      {{ bill.name }}
    </v-card-subtitle>
    <v-divider />
    <v-card-text>
      <v-row>
        <v-ripple-col md="6">
          合同:
          <v-spacer />
          <ContractName :id="bill.contract_id" />
        </v-ripple-col>
        <v-ripple-col md="6">
          业务单据:
          <v-spacer />
          <ExpenseGroupName :id="bill.expense_group_id" />
        </v-ripple-col>
      </v-row>
      <v-row>
        <v-ripple-col
          md="6"
        >
          公司:
          <v-spacer />
          <CompanyName
            :id="bill.company_id"
            short
          />
        </v-ripple-col>
        <v-ripple-col
          md="6"
        >
          团队:
          <v-spacer />
          <TeamName :id="bill.team_id" />
        </v-ripple-col>
      </v-row>
      <v-row>
        <v-ripple-col
          md="6"
        >
          应付金额:
          <v-spacer />
          <span>{{ bill.currency }}</span>
          <space />
          <span>{{ $util.formatPrice(bill.total_amount) }}</span>
        </v-ripple-col>
        <v-ripple-col
          md="6"
        >
          入账会计期:
          <v-spacer />
          {{ bill.handled_at ? $util.formatDate(bill.handled_at) : '无' }}
        </v-ripple-col>
      </v-row>
      <!--<v-row>-->
      <!--  <v-ripple-col>-->
      <!--    备注:-->
      <!--    <space />-->
      <!--    <span>{{ bill.remark || '无' }}</span>-->
      <!--  </v-ripple-col>-->
      <!--</v-row>-->
    </v-card-text>
    <v-card-actions>
      <v-btn
        icon
        @click="toggleExpand"
      >
        <v-icon>{{ expand ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="is_financer"
        color="primary"
        text
        @click="emitEditEvent"
      >
        <v-icon>mdi-pencil-outline</v-icon>
        修改
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-if="expand">
        <v-divider />

        <VOverlayLoading
          :value="item_loading"
        />

        <v-card-text v-if="items.length">
          <v-card
            v-for="(item, index) in items"
            :key="item.id"
            class="item"
            outlined
          >
            <v-card-text>
              <v-row>
                <v-ripple-col
                  md="6"
                >
                  项目 {{ index+1 }}:
                  <v-spacer />
                  {{ item.name }}
                </v-ripple-col>
                <v-ripple-col
                  md="6"
                >
                  承担团队:
                  <v-spacer />
                  <TeamName :id="item.team_id" />
                </v-ripple-col>
              </v-row>
              <v-row>
                <v-ripple-col
                  md="6"
                >
                  应付金额:
                  <v-spacer />
                  {{ bill.currency }}
                  <space />
                  {{ $util.formatPrice(item.total_amount) }}
                </v-ripple-col>
                <v-ripple-col
                  md="6"
                >
                  人民币总金额:
                  <v-spacer />
                  CNY
                  <space />
                  {{ $util.formatPrice(item.cny_total_amount) }}
                </v-ripple-col>
              </v-row>
              <v-row>
                <v-ripple-col
                  md="6"
                >
                  税费:
                  <v-spacer />
                  {{ bill.currency }}
                  <space />
                  {{ $util.formatPrice(item.tax) }}
                </v-ripple-col>
              </v-row>
              <v-row>
                <v-ripple-col
                  md="6"
                >
                  会计科目:
                  <v-spacer />
                  <AccountTitle :id="item.account_title_id" />
                </v-ripple-col>
                <v-ripple-col
                  md="6"
                >
                  分析科目:
                  <v-spacer />
                  <AnalysisTitle :id="item.analysis_title_id" />
                </v-ripple-col>
              </v-row>
              <!--<v-row>-->
              <!--  <v-ripple-col>-->
              <!--    备注:-->
              <!--    <space />-->
              <!--    {{ item.remark || '无' }}-->
              <!--  </v-ripple-col>-->
              <!--</v-row>-->
            </v-card-text>
          </v-card>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  import CompanyName from '../../company/components/name';
  import TeamName from '../../team/components/name';
  import AccountTitle from './account_title';
  import AnalysisTitle from './analysis_title';
  import ContractName from "../../contract/components/name";
  import ExpenseGroupName from "../../expense_group/components/name";
  import VOverlayLoading from '../../../vuetify_custom/v-overlay-loading';
  import {mapGetters} from "vuex";

  export default {
    components: {
      'v-ripple-col': VRippleCol,
      CompanyName, TeamName,
      AccountTitle, AnalysisTitle,
      ContractName, ExpenseGroupName,
      VOverlayLoading },
    props: {
      data: {
        type: Object
      },
      id: {
        type: Number
      }
    },
    data() {
      return {
        bill: {},
        items: [],
        expand: false,
        item_loading: false
      }
    },
    computed: {
      elevation() {
        return this.expand ? 12 : 0;
      },
      ...mapGetters(['is_financer'])
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        if (this.data && this.data.id) {
          this.bill = this.data;
        } else {
          this.loadData();
        }
      },
      loadData() {
        //
      },
      emitEditEvent() {
        this.$emit('edit', this.bill);
      },
      toggleExpand() {
        this.expand = !this.expand;
        if (this.expand) {
          this.loadItems();
        }
      },
      loadItems() {
        if (this.items.length) return;
        this.item_loading = true;
        this.$http.get('fin_payable_bill/items', {
          id: this.bill.id
        }).then(({items}) => {
          this.items = items;
        }).finally(() => {
          this.item_loading = false;
        })
      }
    }
  }
</script>
